/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemBase,
  ItemBaseOptional,
  ItemBaseMetaI,
  ItemBaseTrackedI,
} from "./item-base";
import { ItemBaseTracked, ItemBaseMeta } from "./item-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemRef,
  ItemRefOptional,
  ItemRefMetaI,
  ItemRefTrackedI,
} from "./item-ref";
import { ItemRefTracked, ItemRefMeta } from "./item-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemType,
  ItemTypeOptional,
  ItemTypeMetaI,
  ItemTypeTrackedI,
} from "./item-type";
import { ItemTypeTracked, ItemTypeMeta } from "./item-type";

/**
 *
 * @export
 * @interface CatalogItemReportItemDTO
 */
export interface CatalogItemReportItemDTOOptional extends ItemBaseOptional {
  /**
   *
   * @type {number}
   * @memberof CatalogItemReportItemDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  tempID?: string;
  /**
   *
   * @type {ItemType}
   * @memberof CatalogItemReportItemDTO
   */
  itemType?: ItemType;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  itemName?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  itemDescription?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  imageURL?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  itemSKU?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  squareItemId?: string;
  /**
   * Default expiration duration in seconds for line items of this item type
   * @type {number}
   * @memberof CatalogItemReportItemDTO
   */
  expirationDurationSeconds?: number;
}

export interface CatalogItemReportItemDTO
  extends CatalogItemReportItemDTOOptional, ItemBase, ItemRef {
  /**
   *
   * @type {number}
   * @memberof CatalogItemReportItemDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  tempID?: string;
  /**
   *
   * @type {ItemType}
   * @memberof CatalogItemReportItemDTO
   */
  itemType?: ItemType;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  itemName?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  itemDescription?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  imageURL?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  itemSKU?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  squareItemId?: string;
  /**
   * Default expiration duration in seconds for line items of this item type
   * @type {number}
   * @memberof CatalogItemReportItemDTO
   */
  expirationDurationSeconds?: number;
}

export interface CatalogItemReportItemDTOTrackedI extends ItemBaseOptional {
  /**
   *
   * @type {number}
   * @memberof CatalogItemReportItemDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {ItemType}
   * @memberof CatalogItemReportItemDTO
   */
  itemType?: ItemType;
  itemTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  itemName?: string;
  itemNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  itemDescription?: string;
  itemDescriptionIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  imageURL?: string;
  imageURLIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  itemSKU?: string;
  itemSKUIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemReportItemDTO
   */
  squareItemId?: string;
  squareItemIdIsSet: boolean;
  /**
   * Default expiration duration in seconds for line items of this item type
   * @type {number}
   * @memberof CatalogItemReportItemDTO
   */
  expirationDurationSeconds?: number;
  expirationDurationSecondsIsSet: boolean;
}

transformDatesMap.set(
  "CatalogItemReportItemDTO",
  function (model: CatalogItemReportItemDTO) {},
);

export type CatalogItemReportItemDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  itemType: PropertyMeta<ItemTypeMetaI>;
  //isDate: false
  //isDatetime: false
  itemName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  itemDescription: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  imageURL: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  itemSKU: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  squareItemId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  expirationDurationSeconds: PropertyMeta<MetaTypeBase<number>>;
}>;

export var CatalogItemReportItemDTOMeta: CatalogItemReportItemDTOMetaI =
  {} as CatalogItemReportItemDTOMetaI;
CatalogItemReportItemDTOMeta = typeMeta("CatalogItemReportItemDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
  itemType: propertyMeta("itemType", false, false, false, ItemTypeMeta),
  itemName: propertyMeta("itemName", false, false, false, MetaTypesBase.string),
  itemDescription: propertyMeta(
    "itemDescription",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  imageURL: propertyMeta("imageURL", false, false, false, MetaTypesBase.string),
  itemSKU: propertyMeta("itemSKU", false, false, false, MetaTypesBase.string),
  squareItemId: propertyMeta(
    "squareItemId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  expirationDurationSeconds: propertyMeta(
    "expirationDurationSeconds",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = CatalogItemReportItemDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ItemRefMeta]);
  metaI.assignId.inheritedFrom = ItemRefMeta.assignId;
  metaI.tempID.inheritedFrom = ItemRefMeta.tempID;
  metaI.interfaces = metaI.interfaces.concat([ItemBaseMeta]);
  metaI.itemType.inheritedFrom = ItemBaseMeta.itemType;
  metaI.itemName.inheritedFrom = ItemBaseMeta.itemName;
  metaI.itemDescription.inheritedFrom = ItemBaseMeta.itemDescription;
  metaI.imageURL.inheritedFrom = ItemBaseMeta.imageURL;
  metaI.itemSKU.inheritedFrom = ItemBaseMeta.itemSKU;
  metaI.squareItemId.inheritedFrom = ItemBaseMeta.squareItemId;
  metaI.expirationDurationSeconds.inheritedFrom =
    ItemBaseMeta.expirationDurationSeconds;
});

export class CatalogItemReportItemDTOTracked
  extends ItemBaseTracked
  implements CatalogItemReportItemDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  itemType__I?: ItemType = undefined;
  itemTypeIsSet: boolean = false;
  set itemType(v: undefined | ItemType) {
    if (v !== undefined) {
      this.itemType__I = v;
      this.itemTypeIsSet = true;
    } else {
      this.itemType__I = v || undefined;
      this.itemTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemType() {
    return this.itemType__I;
  }
  itemName__I?: string = undefined;
  itemNameIsSet: boolean = false;
  set itemName(v: undefined | string) {
    if (v !== undefined) {
      this.itemName__I = v;
      this.itemNameIsSet = true;
    } else {
      this.itemName__I = v || undefined;
      this.itemNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemName() {
    return this.itemName__I;
  }
  itemDescription__I?: string = undefined;
  itemDescriptionIsSet: boolean = false;
  set itemDescription(v: undefined | string) {
    if (v !== undefined) {
      this.itemDescription__I = v;
      this.itemDescriptionIsSet = true;
    } else {
      this.itemDescription__I = v || undefined;
      this.itemDescriptionIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemDescription() {
    return this.itemDescription__I;
  }
  imageURL__I?: string = undefined;
  imageURLIsSet: boolean = false;
  set imageURL(v: undefined | string) {
    if (v !== undefined) {
      this.imageURL__I = v;
      this.imageURLIsSet = true;
    } else {
      this.imageURL__I = v || undefined;
      this.imageURLIsSet = false;
    }
    this.changeTracker = true;
  }
  get imageURL() {
    return this.imageURL__I;
  }
  itemSKU__I?: string = undefined;
  itemSKUIsSet: boolean = false;
  set itemSKU(v: undefined | string) {
    if (v !== undefined) {
      this.itemSKU__I = v;
      this.itemSKUIsSet = true;
    } else {
      this.itemSKU__I = v || undefined;
      this.itemSKUIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemSKU() {
    return this.itemSKU__I;
  }
  squareItemId__I?: string = undefined;
  squareItemIdIsSet: boolean = false;
  set squareItemId(v: undefined | string) {
    if (v !== undefined) {
      this.squareItemId__I = v;
      this.squareItemIdIsSet = true;
    } else {
      this.squareItemId__I = v || undefined;
      this.squareItemIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get squareItemId() {
    return this.squareItemId__I;
  }
  expirationDurationSeconds__I?: number = undefined;
  expirationDurationSecondsIsSet: boolean = false;
  set expirationDurationSeconds(v: undefined | number) {
    if (v !== undefined) {
      this.expirationDurationSeconds__I = v;
      this.expirationDurationSecondsIsSet = true;
    } else {
      this.expirationDurationSeconds__I = v || undefined;
      this.expirationDurationSecondsIsSet = false;
    }
    this.changeTracker = true;
  }
  get expirationDurationSeconds() {
    return this.expirationDurationSeconds__I;
  }
  constructor(
    config?: CatalogItemReportItemDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: CatalogItemReportItemDTOOptional,
    options?: AssignOptions,
  ): CatalogItemReportItemDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (config.itemType && this.itemTypeApplyFilter(optionsRequired.filter)) {
      this.itemType = config.itemType;
      if (optionsRequired.unassign) this.itemTypeIsSet = false;
      else this.itemTypeIsSet = true;
    }
    if (config.itemName && this.itemNameApplyFilter(optionsRequired.filter)) {
      this.itemName = config.itemName;
      if (optionsRequired.unassign) this.itemNameIsSet = false;
      else this.itemNameIsSet = true;
    }
    if (
      config.itemDescription &&
      this.itemDescriptionApplyFilter(optionsRequired.filter)
    ) {
      this.itemDescription = config.itemDescription;
      if (optionsRequired.unassign) this.itemDescriptionIsSet = false;
      else this.itemDescriptionIsSet = true;
    }
    if (config.imageURL && this.imageURLApplyFilter(optionsRequired.filter)) {
      this.imageURL = config.imageURL;
      if (optionsRequired.unassign) this.imageURLIsSet = false;
      else this.imageURLIsSet = true;
    }
    if (config.itemSKU && this.itemSKUApplyFilter(optionsRequired.filter)) {
      this.itemSKU = config.itemSKU;
      if (optionsRequired.unassign) this.itemSKUIsSet = false;
      else this.itemSKUIsSet = true;
    }
    if (
      config.squareItemId &&
      this.squareItemIdApplyFilter(optionsRequired.filter)
    ) {
      this.squareItemId = config.squareItemId;
      if (optionsRequired.unassign) this.squareItemIdIsSet = false;
      else this.squareItemIdIsSet = true;
    }
    if (
      config.expirationDurationSeconds &&
      this.expirationDurationSecondsApplyFilter(optionsRequired.filter)
    ) {
      this.expirationDurationSeconds = config.expirationDurationSeconds;
      if (optionsRequired.unassign) this.expirationDurationSecondsIsSet = false;
      else this.expirationDurationSecondsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CatalogItemReportItemDTOTrackedI {
    const cloned = {} as CatalogItemReportItemDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.itemTypeIsSetDeep() &&
      this.itemTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemTypeIsSet = true;
      cloned.itemType = this.itemType;
    } else {
      //cloned.itemTypeIsSet = false
    }
    if (
      this.itemNameIsSetDeep() &&
      this.itemNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemNameIsSet = true;
      cloned.itemName = this.itemName;
    } else {
      //cloned.itemNameIsSet = false
    }
    if (
      this.itemDescriptionIsSetDeep() &&
      this.itemDescriptionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemDescriptionIsSet = true;
      cloned.itemDescription = this.itemDescription;
    } else {
      //cloned.itemDescriptionIsSet = false
    }
    if (
      this.imageURLIsSetDeep() &&
      this.imageURLApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.imageURLIsSet = true;
      cloned.imageURL = this.imageURL;
    } else {
      //cloned.imageURLIsSet = false
    }
    if (
      this.itemSKUIsSetDeep() &&
      this.itemSKUApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemSKUIsSet = true;
      cloned.itemSKU = this.itemSKU;
    } else {
      //cloned.itemSKUIsSet = false
    }
    if (
      this.squareItemIdIsSetDeep() &&
      this.squareItemIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squareItemIdIsSet = true;
      cloned.squareItemId = this.squareItemId;
    } else {
      //cloned.squareItemIdIsSet = false
    }
    if (
      this.expirationDurationSecondsIsSetDeep() &&
      this.expirationDurationSecondsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.expirationDurationSecondsIsSet = true;
      cloned.expirationDurationSeconds = this.expirationDurationSeconds;
    } else {
      //cloned.expirationDurationSecondsIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CatalogItemReportItemDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.itemTypeApplyFilter(filter)) this.itemTypeIsSet = false;

    if (!this.itemNameApplyFilter(filter)) this.itemNameIsSet = false;

    if (!this.itemDescriptionApplyFilter(filter))
      this.itemDescriptionIsSet = false;

    if (!this.imageURLApplyFilter(filter)) this.imageURLIsSet = false;

    if (!this.itemSKUApplyFilter(filter)) this.itemSKUIsSet = false;

    if (!this.squareItemIdApplyFilter(filter)) this.squareItemIdIsSet = false;

    if (!this.expirationDurationSecondsApplyFilter(filter))
      this.expirationDurationSecondsIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemReportItemDTOMeta.assignId,
      CatalogItemReportItemDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemReportItemDTOMeta.tempID,
      CatalogItemReportItemDTOMeta,
      this.tempID,
      this,
    );
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  itemTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemReportItemDTOMeta.itemType,
      CatalogItemReportItemDTOMeta,
      this.itemType,
      this,
    );
  }
  itemTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemTypeIsSet && this.itemTypeApplyFilter(filter)) return true;

    return false;
  }
  itemNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemReportItemDTOMeta.itemName,
      CatalogItemReportItemDTOMeta,
      this.itemName,
      this,
    );
  }
  itemNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemNameIsSet && this.itemNameApplyFilter(filter)) return true;

    return false;
  }
  itemDescriptionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemReportItemDTOMeta.itemDescription,
      CatalogItemReportItemDTOMeta,
      this.itemDescription,
      this,
    );
  }
  itemDescriptionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemDescriptionIsSet && this.itemDescriptionApplyFilter(filter))
      return true;

    return false;
  }
  imageURLApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemReportItemDTOMeta.imageURL,
      CatalogItemReportItemDTOMeta,
      this.imageURL,
      this,
    );
  }
  imageURLIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.imageURLIsSet && this.imageURLApplyFilter(filter)) return true;

    return false;
  }
  itemSKUApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemReportItemDTOMeta.itemSKU,
      CatalogItemReportItemDTOMeta,
      this.itemSKU,
      this,
    );
  }
  itemSKUIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemSKUIsSet && this.itemSKUApplyFilter(filter)) return true;

    return false;
  }
  squareItemIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemReportItemDTOMeta.squareItemId,
      CatalogItemReportItemDTOMeta,
      this.squareItemId,
      this,
    );
  }
  squareItemIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.squareItemIdIsSet && this.squareItemIdApplyFilter(filter))
      return true;

    return false;
  }
  expirationDurationSecondsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemReportItemDTOMeta.expirationDurationSeconds,
      CatalogItemReportItemDTOMeta,
      this.expirationDurationSeconds,
      this,
    );
  }
  expirationDurationSecondsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.expirationDurationSecondsIsSet &&
      this.expirationDurationSecondsApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.itemTypeIsSetDeep(filter)) return true;
    if (this.itemNameIsSetDeep(filter)) return true;
    if (this.itemDescriptionIsSetDeep(filter)) return true;
    if (this.imageURLIsSetDeep(filter)) return true;
    if (this.itemSKUIsSetDeep(filter)) return true;
    if (this.squareItemIdIsSetDeep(filter)) return true;
    if (this.expirationDurationSecondsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
